const routes = [
  {
    path: "/",
    name: "index",
    component: () => import("@/views/index.vue"),
    meta: { name: "首页", keys: "index" }
  },
  {
    path: "/abouts",
    name: "abouts",
    meta: { name: "关于我们", keys: "abouts" },
    children: [{
      path: "/profile",
      name: "profile",
      component: () => import("@/views/abouts/profile.vue"),
      meta: { name: "公司简介", keys: "abouts", names: "关于我们" },
    }, 
    // {
    //   path: "/qualifications",
    //   name: "qualifications",
    //   component: () => import("@/views/abouts/qualifications.vue"),
    //   meta: { name: "资质荣誉", keys: "abouts", names: "关于我们" },
    // }, 
    {
      path: "/cultures",
      name: "cultures",
      component: () => import("@/views/abouts/cultures.vue"),
      meta: { name: "企业文化", keys: "abouts", names: "关于我们" },
    }, 
    // {
    //   path: "/process",
    //   name: "process",
    //   component: () => import("@/views/abouts/process.vue"),
    //   meta: { name: "创新历程", keys: "abouts", names: "关于我们" },
    // }
    ]
  },
  {
    path: "/technical",
    name: "technical",
    component: () => import("@/views/technical.vue"),
    meta: { name: "技术优势", keys: "technical" }
  },
  {
    path: "/caseseries",
    name: "caseseries",
    component: () => import("@/views/caseseries.vue"),
    meta: { name: "应用案例", keys: "caseseries" }
  },
  {
    path: "/Introduction",
    name: "Introduction",
    component: () => import("@/views/Introduction.vue"),
    meta: { name: "产品介绍", keys: "Introduction" }
  },
  {
    path: "/training",
    name: "training",
    component: () => import("@/views/training.vue"),
    meta: { name: "技术培训", keys: "training" }
  },
  {
    path: "/property",
    name: "property",
    component: () => import("@/views/property.vue"),
    meta: { name: "知识产权", keys: "property" }
  },
  {
    path: "/contacts",
    name: "contacts",
    component: () => import("@/views/contacts.vue"),
    meta: { name: "联系我们", keys: "contacts" }
  },
  // {
  //   path: "/searchs",
  //   name: "searchs",
  //   component: () => import("@/views/searchs.vue"),
  //   meta: { name: "搜索", keys: "searchs", dise: true }
  // }
];

export default routes;
